import type { ReactNode } from "react";
import { Side } from "../SMGdestinations/Side";
import { ExtendedLink } from "../ideas/ExtendedLink";

export const listVoyagesCulturels = [
  {
    title: "Circuits",
    href: "/sur-mesure/catalogue/?themes=Circuits+culturels",
  },
];

export const listThemes = [
  {
    title: "Voyages en train",
    href: "/sur-mesure/catalogue/?themes=Voyages+en+train",
  },
];

type Props = {
  catalogueImage: ReactNode;
};
export const SMGIdeas = ({ catalogueImage }: Props) => {
  return (
    <div className="flex gap-6 py-10 container justify-between">
      <div className="flex flex-col gap-1">
        <p className="font-serif text-pr-1 text-base font-medium">Voyages culturels</p>
        {listVoyagesCulturels.map((item) => (
          <ExtendedLink key={item.title} href={item.href}>
            {item.title}
          </ExtendedLink>
        ))}
      </div>
      <div className="flex flex-col gap-1">
        <p className="font-serif text-pr-1 text-base font-medium">Thèmes</p>
        {listThemes.map((item) => (
          <ExtendedLink key={item.title} href={item.href}>
            {item.title}
          </ExtendedLink>
        ))}
      </div>
      <Side catalogueImage={catalogueImage} />
    </div>
  );
};
